/** управление пользователями
 * в самом начале получает список пользователей на сервере
 * строит таблицу и позволяет открывать карточки пользователей
 * для просмотра и редактирования
 * в общем смысле возвращаемая структура данных также должна сообщить
 * о том, какие действия допустимы на странице
 * то есть текущему пользователю, выполняющему запрос, может быть недоступно
 * какое-либо из действий, что должно отразиться на интерфейсе
 * это будет добавлено чуть позже в виде структур access со связанными идентификаторами
 * модулей на бекенде
 */
import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { Table } from "reactstrap";
import moment from "components/moment";
import { useIntl } from "react-intl";
import { Link, useRouteMatch } from "react-router-dom";
import qs from "query-string";
import { adminAPI } from "redux/api";
import { history } from "redux/store";
import { FormButton } from "./Form";
import { AccessControl, phoneNumber } from "components/special";
import { Finder, Pager, Sorter, TableLoading } from "components/standart";
import { limit } from "variables";
import { apiUrls, infoLink } from "./init";

const { api } = adminAPI.actions;

export const ident = "Users";

const AdvertisersTable = (props) => {
  const { url, path } = useRouteMatch();
  const intl = useIntl();
  const [advertisers, setAdvertisers] = useState({ total: 0 });
  const [query, setQuery] = useState({});
  const dateTimeFormat = intl.formatMessage({ id: "dateTimeFormat" });

  useEffect(() => {
    setQuery({ limit, order: "-createdAt", ...qs.parse(history.location.search) });
  }, [history.location]);

  useEffect(() => {
    const onSuccess = (body) => {
      setAdvertisers(body);
    };
    const onRequest = () => {
      setAdvertisers({ total: -1 });
    };

    query.limit && props.getAdvertisers({ query }, { onSuccess, onRequest });
  }, [query]);

  return (
    <AccessControl id={ident}>
      <Table responsive style={{ position: "relative" }}>
        <thead
          style={{
            position: "sticky",
            top: 0,
            boxShadow: "0 2px 2px -1px rgba(0, 0, 0, 0.4)",
          }}
        >
          <tr>
            <th>
              <Finder className="mr-1 d-inline" isActive={query.name}>
                <Finder.input name="name" {...{ query, setQuery }} />
              </Finder>
              <IntlMessages id="Advertisers.name" />
            </th>

            <th>
              <IntlMessages id="tables.created" />
              <Sorter query={query} url={url} order="createdAt" />
            </th>
            <th>
              <Finder.search {...{ query, url }} />
            </th>
          </tr>
        </thead>
        {advertisers.total < 0 && <TableLoading />}
        <tbody>
          {_.map(advertisers.data, (advertiser, key) => {
            return (
              <tr key={key} className={!advertiser.enabled ? "text-strike" : ""}>
                <td>
                  <Link to={infoLink(advertiser)}>{advertiser.name}</Link>
                </td>

                <td>{moment(advertiser.createdAt).format(dateTimeFormat)}</td>
                <td>
                  <FormButton {...advertiser} className="btn btn-sm btn-secondary" />
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="99">
              <Pager query={query} url={url} total={advertisers.total} />
            </td>
          </tr>
        </tfoot>
      </Table>
    </AccessControl>
  );
};

export default connect(null, {
  getAdvertisers: api.get(apiUrls.list),
})(AdvertisersTable);
